// extracted by mini-css-extract-plugin
export default {"box":"SaveValue_box__WG07j","union":"SaveValue_union__Evdro","label":"SaveValue_label__IHg7h"};